import { useMedia } from "react-use"

import { focusModeWidth } from "@/constants"

// Focus mode activates on mobile/narrow viewports where the sidebar and detail
// panel can't be shown side-by-side, so only one panel is visible at a time.
export function useFocusMode() {
	const isFocusMode = !useMedia(focusModeWidth)
	return { isFocusMode }
}
